import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { Router } from '@angular/router';

import { Observable, Subject, Subscription, tap } from 'rxjs';

import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { UserService } from 'src/app/auth/services/user.service';
import {
  BreadCrumbNavigationLevel,
  MenuItem,
} from 'src/app/shared/framework/navigation/models/MenuItem';
import { Company } from 'src/app/shared/personnel-files/models/Company';
import { CompanyService } from 'src/app/shared/personnel-files/services/company.service';
import { StudentRoleSettings, UserLevelEnum } from 'src/app/auth/models/UserData';

@Component({
  selector: '[app-bread-crumb-navigation-item]',
  templateUrl: './bread-crumb-navigation-item.component.html',
  styleUrls: ['./bread-crumb-navigation-item.component.scss'],
})
export class BreadCrumbNavigationItemComponent implements OnInit, OnDestroy {
  private _subscriptions: Subscription[] = [];

  @Input() level: BreadCrumbNavigationLevel;
  @Input() top = false;
  @Input() noActiveMenuItemFound = false;
  @Input() events: Observable<void>;

  @ViewChild('leveldrop') leveldrop: NgbDropdown;
  @ViewChild('dropdownMenu') dropdownMenu: ElementRef<HTMLDivElement>;
  @ViewChild('modalcontent') modalcontent: any;
  @ViewChildren('submenu') submenus: ElementRef<HTMLDivElement>[];

  public id: string;
  public dropdownBackDrop = false;
  public disableTopMouseLeave = false;
  public isMobileDevice = false;
  public backdropLeft = 425;

  public companies: Company[] = [];

  public roles$: Observable<StudentRoleSettings>;
  public roleLabel = '';
  public Roles = UserLevelEnum;

  eventsSubject: Subject<void> = new Subject<void>();

  private eventsSubscription: Subscription;

  constructor(
    private companyService: CompanyService,
    private modalService: NgbModal,
    private router: Router,
    private _userService: UserService
  ) {
    this.id = new Date().getTime() + '' + Math.floor(Math.random() * 101);
  }

  ngOnInit() {
    this.companyService.get().subscribe(e => {
      this.companies = e.filter(c => c.id > 1);
    })

    let userAgent = navigator.userAgent.toLowerCase();
    this.isMobileDevice =
      /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent) ||
      /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/i.test(
        userAgent
      );
    if (document.getElementById('roleDrop')) {
      this.backdropLeft = document.getElementById('roleDrop').clientWidth;
    }

    this.eventsSubscription = this.events.subscribe(() => {
      setTimeout(() => {
        this.resize();
      });
    });

    setTimeout(() => {
      this.resize();
    });

    setTimeout(() => {
      this.resize();
    }, 2500);

    this.roles$ = this._userService.getUserRoles().pipe(
      tap((roles) => {
        if (roles && roles.level) {
          let role = this.Roles[roles.level];
          if (roles.isManager && localStorage.getItem('manager_view') === '1') {
            role = 'manager';
          }
          this.roleLabel = role;
          this.eventsSubject.next();
        }
      })
    );
  }

  @HostListener('window:resize')
  public resize() {
    if (
      document.getElementById('roleDrop') &&
      document.getElementById('roleDrop').clientWidth != this.backdropLeft
    ) {
      this.backdropLeft = document.getElementById('roleDrop').clientWidth;
    }
  }

  public onHover(open = false, forceLeave = false) {
    this.resize();

    if (open) {
      this.leveldrop.open();
      this.dropdownBackDrop = true;
    } else if (!this.disableTopMouseLeave || forceLeave) {
      this.dropdownBackDrop = false;
      for (const ms of this.level.menuItems) {
        ms.showChildren = false;
        for (const mss of ms.subPages) {
          mss.showChildren = false;
          for (const msss of mss.subPages) {
            msss.showChildren = false;
            for (const mssss of msss.subPages) {
              mssss.showChildren = false;
            }
          }
        }
      }
    }
  }

  public openSubmenu(menuItem: MenuItem) {
    for (const ms of this.level.menuItems) {
      ms.showChildren = false;
      for (const mss of ms.subPages) {
        mss.showChildren = false;
        for (const msss of mss.subPages) {
          msss.showChildren = false;
          for (const mssss of msss.subPages) {
            mssss.showChildren = false;
          }
        }
      }
    }

    menuItem.showChildren = true;

    if (menuItem.parent) {
      menuItem.parent.showChildren = true;
      for (const ms of menuItem.parent.subPages.filter(
        (e) => e.id != menuItem.id
      )) {
        ms.showChildren = false;
      }

      if (menuItem.parent.parent) {
        menuItem.parent.parent.showChildren = true;
        for (const ms2 of menuItem.parent.parent.subPages.filter(
          (e) => e.id != menuItem.parent.id
        )) {
          ms2.showChildren = false;
        }

        if (menuItem.parent.parent.parent) {
          menuItem.parent.parent.parent.showChildren = true;
          for (const ms3 of menuItem.parent.parent.parent.subPages.filter(
            (e) => e.id != menuItem.parent.parent.id
          )) {
            ms3.showChildren = false;
          }

          if (menuItem.parent.parent.parent.parent) {
            menuItem.parent.parent.parent.parent.showChildren = true;
            for (const ms4 of menuItem.parent.parent.parent.parent.subPages.filter(
              (e) => e.id != menuItem.parent.parent.parent.id
            )) {
              ms4.showChildren = false;
            }
          }
        }
      }
    }
  }

  public getUserColor() {
    switch (this.roleLabel) {
      case 'Employee': return 'var(--progreso-accent)';
      case 'manager': return 'var(--progreso-accent-hover)';
      case 'Trainer': return 'var(--progreso-primary)';
      case 'LocalHr': return 'var(--progreso-secondary)';
      case 'CorporateHr': return 'var(--progreso-secondary)';
      default: return 'var(--progreso-accent)';
    }
  }

  navigate(event: any, menuItem: MenuItem, forceNewTab = false) {
    event = event || window.event;

    if (menuItem && menuItem.getAngularUrl() && (menuItem.id != 697 && menuItem.id != 698 && menuItem.id != 699 && menuItem.id != 700)) {
      this.navigateToUrl(menuItem.getAngularUrl(), menuItem, event, forceNewTab);
    }

    if (menuItem && (menuItem.id == 697 || menuItem.id == 698 || menuItem.id == 699 || menuItem.id == 700)) {
      let parameters = {};
      let url = 'chr/company';
      switch (menuItem.id) {
        case 697: url = 'chr/companydepartments';
          break;
        case 698:
        case 699: url = 'chr/companypositions';
          break;
        case 700: url = 'chr/companyfunctions';
          break;
      }

      if (this.companies.length == 1) {
        parameters['item'] = this.companies[0].id;
        this.navigateToUrl(url, menuItem, event, forceNewTab, parameters);
      } else {
        let modal = this.modalService.open(this.modalcontent, { centered: false, backdrop: true, size: 'sm' });
        modal.result.then((a) => {
          parameters['item'] = a;
          this.navigateToUrl(url, menuItem, event, forceNewTab, parameters);
        }, () => { })
      }
    }
  }

  private navigateToUrl(url: string, menuItem: MenuItem, event, forceNewTab, extraQueryParams?) {
    let isCtrlClick = event.ctrlKey || event.metaKey || event.which == 2 || event.button == 4;
    if (isCtrlClick || forceNewTab) {
      let newUrl = this.router.createUrlTree([url], { queryParams: { menuItem: menuItem.id, ...extraQueryParams }, queryParamsHandling: 'merge' });
      let topUrl = window.top.location.href.split('?')[0];
      topUrl = topUrl.split('#')[0];
      window.open(topUrl + '?redirectchild=' + encodeURIComponent(newUrl.toString()), '_blank');
    } else {
      this.router.navigate([url], { queryParams: { menuItem: menuItem.id, ...extraQueryParams }, queryParamsHandling: 'merge' });
    }
  }

  ngOnDestroy() {
    this.eventsSubscription.unsubscribe();
  }
}
